const personalBanks = [
  {id: 0, name: 'No bank A/C'},
  {id: 1, name: 'Emirates NBD'},
  {id: 2, name: 'Mashreq'},
  {id: 3, name: 'RAK Bank'},
  {id: 4, name: 'Noor Bank'},
  {id: 5, name: 'ADIB'},
  {id: 6, name: 'Emirates Islamic'},
  {id: 7, name: 'DIB'},
  {id: 8, name: 'FAB'},
  {id: 9, name: 'ADCB'}
]

export default personalBanks



// WEBPACK FOOTER //
// ./src/constants/personalBanks.js